import { ApiService } from 'services';
import { omit, omitBy, get } from 'lodash';
const URL_HOLDER = '/holders';

async function getHolder(id = null) {
  return await ApiService.callApiAuthenticated({
    method: 'GET',
    path: id ? `${URL_HOLDER}/${id}` : `${URL_HOLDER}/me`,
  });
}

async function updateHolder(id, updateHolder) {
  return await ApiService.callApiAuthenticated({
    method: 'PATCH',
    path: `${URL_HOLDER}/${id}`,
    body: updateHolder,
  });
}

async function getTokenLinks(id) {
  return await ApiService.callApiAuthenticated({
    method: 'GET',
    path: `/tokens/${id}/links`,
    body: updateHolder,
  });
}

function getTransactions(id, query) {
  const cleanQuery = omitBy(query, (value) => !value);
  const filter = get(cleanQuery, 'filter');
  return ApiService.callApiAuthenticated({
    method: 'GET',
    path: `/tokens/${id}/transactions/me`,
    queryParams: {
      ...omit(cleanQuery, 'filter'),
      ...filter,
    },
  });
}

function getBalances(id) {
  return ApiService.callApiAuthenticated({
    method: 'GET',
    path: `/tokens/${id}/balances/me`,
  });
}

function getTokenHolder(id) {
  return ApiService.callApiAuthenticated({
    method: 'GET',
    path: `/tokens/${id}/holders/me`,
  });
}

function getHolderByWallet(tokenId, wallet) {
  return ApiService.callApiAuthenticated({
    method: 'GET',
    path: `/tokens/${tokenId}/holders/wallet/${wallet}`,
  });
}

export default {
  getBalances,
  getHolder,
  getTransactions,
  getTokenHolder,
  getHolderByWallet,
  updateHolder,
  getTokenLinks,
};
